import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Reveal, Overline } from "@/components/Reveal";

export default function Blog() {
    const [posts, setPosts] = useState([]);
    useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);

    return (
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
            <Reveal>
                <Overline>Spiritual Journal</Overline>
                <h1 className="mt-3 font-serif text-5xl sm:text-6xl text-cream">Rituals, Tips &amp; Roots</h1>
                <p className="mt-4 text-ash max-w-2xl">Sherrie's teachings on rootwork, cleansing, and the old ways.</p>
            </Reveal>

            <div className="mt-12 grid md:grid-cols-3 gap-8">
                {posts.map((p, i) => (
                    <Reveal key={p.id} delay={(i % 3) * 0.08}>
                        <Link to={`/journal/${p.slug}`} data-testid={`blog-${p.slug}`} className="group block">
                            <div className="relative aspect-[3/2] overflow-hidden rounded-2xl border border-gold/10">
                                <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                            </div>
                            <div className="mt-4 flex flex-wrap gap-2">{(p.tags || []).map((t) => <span key={t} className="text-[10px] uppercase tracking-widest text-gold">#{t}</span>)}</div>
                            <h3 className="mt-2 font-serif text-2xl text-cream group-hover:text-gold transition-colors">{p.title}</h3>
                            <p className="mt-2 text-sm text-ash line-clamp-2">{p.excerpt}</p>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </div>
    );
}
